import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { PAYMENT_LINK_APIS } from "features/PaymentLinks/constants/PaymentLinks.apis";
import {
  QR_PAYMENT_STATUS_CODES,
  QR_WARNING_BANNER_QUERY_KEYS,
  QR_BANNER_QUERY_CONFIG,
  QR_BANNER_CACHE_TIME,
  QR_BANNER_STALE_TIME,
} from "ui/pages/transactions/QrPayments/constants/qrPayments.constants";

export const useQrWarningBanner = () => {
  // Query successful QR payments
  const { data: successData } = useCustomQuery({
    url: PAYMENT_LINK_APIS.qr_list,
    params: {
      ...QR_BANNER_QUERY_CONFIG,
      status: QR_PAYMENT_STATUS_CODES.SUCCESS,
    },
    queryKey: [QR_WARNING_BANNER_QUERY_KEYS.SUCCESS_COUNT],
    cacheTime: QR_BANNER_CACHE_TIME,
    staleTime: QR_BANNER_STALE_TIME,
  });

  // Query failed QR payments
  const { data: failedData } = useCustomQuery({
    url: PAYMENT_LINK_APIS.qr_list,
    params: {
      ...QR_BANNER_QUERY_CONFIG,
      status: QR_PAYMENT_STATUS_CODES.FAILED,
    },
    queryKey: [QR_WARNING_BANNER_QUERY_KEYS.FAILED_COUNT],
    cacheTime: QR_BANNER_CACHE_TIME,
    staleTime: QR_BANNER_STALE_TIME,
  });

  const successCount = successData?.total || 0;
  const failedCount = failedData?.total || 0;
  const isSuccess = successCount > 0;

  return {
    successCount,
    failedCount,
    isSuccess,
  };
};
